import { addSessionTokenHeaders, handleSessionTokenError } from '../../../funnel/src/services/apiClient'

const urlBase = process.env.REACT_APP_BACKEND_URL
const backEntryPoint = process.env.REACT_APP_BACKEND_ENTRY_POINT

const makeCommonHeaders = async (extraHeaders = {}) => {
  // Agregar headers de session token
  const sessionHeaders = await addSessionTokenHeaders({
    Accept: 'application/json',
    ...extraHeaders,
  })
  return sessionHeaders
}

const readUrl = (url = '', entryPoint = backEntryPoint, urlPrefix = urlBase) => new URL(`${urlPrefix}/${entryPoint}/${url}`).href
const readExternalUrl = (urlBase = '', entryPoint = backEntryPoint) => new URL(`${urlBase}/${entryPoint}`).href

const checkResponse = async (response) => {
  if (!response.ok) {
    throw response
  }
  const data = await response.json()
  return data
}

const get = async (url = '', headers = {}, entryPoint = backEntryPoint, urlPrefix = urlBase) => {
  const requestHeaders = await makeCommonHeaders(headers)
  const res = await fetch(readUrl(url, entryPoint, urlPrefix), {
    method: 'GET',
    headers: requestHeaders,
  })

  // Manejar errores de session token
  if (!res.ok) {
    await handleSessionTokenError(res)
  }

  return await checkResponse(res)
}
const getExternal = async (urlBase = '', headers = {}, entryPoint = backEntryPoint) => {
  const requestHeaders = await makeCommonHeaders(headers)
  const res = await fetch(readExternalUrl(urlBase, entryPoint), {
    method: 'GET',
    headers: requestHeaders,
  })

  // Manejar errores de session token
  if (!res.ok) {
    await handleSessionTokenError(res)
  }

  return await checkResponse(res)
}

export { get, getExternal, makeCommonHeaders, checkResponse }